import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Name from '../views/Name.vue'
import Words from '../views/Words.vue'
import Board from '../views/Board.vue'
import Game from '../views/Game.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'name',
    component: Name
  },
  {
    path: '/words',
    name: 'words',
    component: Words
  },
  {
    path: '/board',
    name: 'board',
    component: Board
  },
  {
    path: '/game',
    name: 'game',
    component: Game
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
